import LogoFid from "./shares/LogoFid";
import AppButton from "./shares/AppButton";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();
  const current_url = window.location.href;
  const is_administration = current_url.split("/")[4] === "administration";
  return (
    <div style={{ textAlign: "center", marginTop: "50px", height: "60vh" }}>
      <LogoFid largeur={300} />
      <h1>404 - Page non trouvée</h1>
      <p>La page que vous cherchez n'existe pas.</p>
      <AppButton
        text={"Revenir à la page d'accueil"}
        variant={"contained"}
        color={"primary"}
        onClick={() => navigate(is_administration ? "/administration" : "/")}
      />
    </div>
  );
};

export default NotFound;
